export default __webpack_public_path__ + "static/media/card-asesor.de47234c.png";